import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../__legacy__/models/error.model';
import { IMainApiService } from '../../../__legacy__/services/api.service';
import { IApiService } from '../../../__legacy__/services/api.service.base';
import {
  EditAndAcceptAnnotationRequest,
  EditAndRejectAnnotationRequest,
  IAbandonDraftRequest,
  IAcceptAnnotationRequest,
  ICorrectAndSubmitAnnotationForReviewRequest,
  ICorrectAnnotationRequest,
  IDiscardAnnotationDuringAnnotationRequest,
  IDiscardAnnotationDuringReviewEditRequest,
  IDiscardAnnotationDuringReviewRequest,
  IRejectAnnotationRequest,
  IRequestClarificationDuringAnnotationRequest,
  IRequestClarificationDuringReviewEditRequest,
  IRequestClarificationDuringReviewRequest,
  ISaveAnnotationDraftRequest,
  ISubmitAnnotationForReviewRequest,
} from '../models/Requests';

export namespace IBatchAnnotationApiService {
  export const $: interfaces.ServiceIdentifier<IBatchAnnotationApiService> = Symbol('BATCH_ANNOTATION_API_SERVICE');
}

export interface IBatchAnnotationApiService {
  submitForReview(annotation: ISubmitAnnotationForReviewRequest): Promise<void | ACDLError>;
  discardDuringAnnotation(request: IDiscardAnnotationDuringAnnotationRequest): Promise<void | ACDLError>;
  saveDraft(request: ISaveAnnotationDraftRequest): Promise<void | ACDLError>;
  abandonDraft(request: IAbandonDraftRequest): Promise<void | ACDLError>;

  editAndAcceptAsync(request: EditAndAcceptAnnotationRequest): Promise<void | ACDLError>;
  editAndRejectAsync(request: EditAndRejectAnnotationRequest): Promise<void | ACDLError>;

  acceptAsync(request: IAcceptAnnotationRequest): Promise<void | ACDLError>;
  rejectAsync(request: IRejectAnnotationRequest): Promise<void | ACDLError>;

  discardDuringReviewAsync(request: IDiscardAnnotationDuringReviewRequest): Promise<void | ACDLError>;
  discardDuringReviewEditAsync(request: IDiscardAnnotationDuringReviewEditRequest): Promise<void | ACDLError>;

  correctAsync(request: ICorrectAnnotationRequest): Promise<void | ACDLError>;
  correctAndSubmitForReviewAsync(request: ICorrectAndSubmitAnnotationForReviewRequest): Promise<void | ACDLError>;

  requestClarificationDuringAnnotationAsync(request: IRequestClarificationDuringAnnotationRequest): Promise<void | ACDLError>;
  requestClarificationDuringReviewAsync(request: IRequestClarificationDuringReviewRequest): Promise<void | ACDLError>;
  requestClarificationDuringReviewEditAsync(request: IRequestClarificationDuringReviewEditRequest): Promise<void | ACDLError>;
}

@injectable()
export class BatchAnnotationApiService implements IBatchAnnotationApiService {
  constructor(@inject(IMainApiService.$) private readonly apiService: IApiService) {}

  acceptAsync = async (request: IAcceptAnnotationRequest): Promise<void | ACDLError> => await this.apiService.postAsync('/annotation/batch/Accept', request);

  rejectAsync = async (request: IRejectAnnotationRequest): Promise<void | ACDLError> => await this.apiService.postAsync('/annotation/batch/Reject', request);

  editAndAcceptAsync = async (request: EditAndAcceptAnnotationRequest): Promise<void | ACDLError> =>
    await this.apiService.postAsync('/annotation/batch/EditAndAccept', request);

  editAndRejectAsync = async (request: EditAndRejectAnnotationRequest): Promise<void | ACDLError> =>
    await this.apiService.postAsync('/annotation/batch/EditAndReject', request);

  submitForReview = async (request: ISubmitAnnotationForReviewRequest): Promise<void | ACDLError> =>
    this.apiService.postAsync('/annotation/batch/SubmitForReview', request);

  discardDuringAnnotation = async (request: IDiscardAnnotationDuringAnnotationRequest): Promise<void | ACDLError> =>
    this.apiService.postAsync('/annotation/batch/DiscardDuringAnnotation', request);

  discardDuringReviewAsync = async (request: IDiscardAnnotationDuringReviewRequest): Promise<void | ACDLError> =>
    await this.apiService.postAsync('/annotation/batch/DiscardDuringReview', request);

  discardDuringReviewEditAsync = async (request: IDiscardAnnotationDuringReviewEditRequest): Promise<void | ACDLError> =>
    await this.apiService.postAsync('/annotation/batch/DiscardDuringReviewEdit', request);

  saveDraft = async (request: ISaveAnnotationDraftRequest): Promise<void | ACDLError> => this.apiService.postAsync('/annotation/batch/SaveDraft', request);

  correctAsync = async (request: ICorrectAnnotationRequest): Promise<void | ACDLError> => this.apiService.postAsync('/annotation/batch/Correct', request);

  correctAndSubmitForReviewAsync = async (request: ICorrectAndSubmitAnnotationForReviewRequest): Promise<void | ACDLError> =>
    this.apiService.postAsync('/annotation/batch/CorrectAndSubmitForReview', request);

  abandonDraft = async (request: IAbandonDraftRequest): Promise<void | ACDLError> => this.apiService.postAsync('/annotation/batch/AbandonDraft', request);

  requestClarificationDuringAnnotationAsync = async (request: IRequestClarificationDuringAnnotationRequest): Promise<void | ACDLError> =>
    await this.apiService.postAsync('/annotation/batch/RequestClarificationDuringAnnotation', request);

  requestClarificationDuringReviewAsync = async (request: IRequestClarificationDuringReviewRequest): Promise<void | ACDLError> =>
    await this.apiService.postAsync('/annotation/batch/RequestClarificationDuringReview', request);

  requestClarificationDuringReviewEditAsync = async (request: IRequestClarificationDuringReviewEditRequest): Promise<void | ACDLError> =>
    await this.apiService.postAsync('/annotation/batch/RequestClarificationDuringReviewEdit', request);
}
